import { ComponentProps } from "react";
import { Button } from "../../button";
import "./sms-sent.scss";
import { useAppSelector } from "../../../../hooks/hooks";
import {
  selectLanguage,
  selectTranslations,
} from "../../../data-access/store/general/generalSlice";
import { checkTranslationKey } from "../../../../utils/translation";

export interface SmsSentProps extends ComponentProps<"div"> {
  phone: string;
  onButtonClick: () => void;
  buttonText: string;
  instructions: string;
}

export function SmsSent({
  phone,
  onButtonClick,
  buttonText,
  instructions,
  ...props
}: SmsSentProps) {
  const lang = useAppSelector(selectLanguage);
  const translations = useAppSelector(selectTranslations);

  return (
    <div className="sms-sent-modal modal-content" {...props}>
      <div className="top-area">
        <div className="title">
          {checkTranslationKey(translations[lang]?.SMS_sent, "SMS sent!")}
        </div>
        <div className="message-icon">
          <img src="../img/icns/message.png" alt="" width="60em" />
        </div>
        <div className="message">
          <div className="text">{instructions}</div>
          <div className="phone">{phone}</div>
        </div>
      </div>
      <div className="bottom-area" style={{ background: "white" }}>
        <Button onClick={onButtonClick} buttonType="success">
          {buttonText}
        </Button>
      </div>
    </div>
  );
}

export default SmsSent;
